module.exports = __webpack_public_path__ + "static/img/banner6.9c67c2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/常规分子项目/banner6.jpg
// module id = NvK7
// module chunks = 16